
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/Checkbox.html",
      function () {
        return require("private-next-pages/Forms/Checkbox.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/Checkbox.html"])
      });
    }
  